import { ReactNode, CSSProperties } from "react";

export function PanelContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`p-[40px_30px] flex flex-col gap-[30px] ${className ?? ""}`}
    >
      {children}
    </div>
  );
}

export function PanelRow({
  children,
  className,
  style,
  onClick,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}) {
  return (
    <div
      className={`flex items-center gap-[22px] text-primary-black [&_svg]:w-6 [&_svg]:min-w-6 [&_svg]:h-6 [&_.text]:flex [&_.text]:flex-col [&_.label]:text-[17px] [&_.label]:font-semibold [&_.description]:text-[15px] [&_.description]:font-normal ${className ?? ""}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
